import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.separator}`
  },
  description: {
    color: theme.palette.text.secondary,
    paddingTop: theme.spacing(2)
  },
  content: {
    flex: 1
  },
  header: {
    display: 'flex',
    flexDirection: 'row'
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(1)
  },
  subject: {
    flex: 1
  },
  text: {
    textTransform: 'uppercase',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center'
  },
  item: {
    marginLeft: theme.spacing(3)
  },
  title: {
    color: theme.videoconferences?.item.title,
    fontWeight: 400,
    textAlign: 'right'
  },
  value: {
    marginTop: theme.spacing(1),
    textAlign: 'right',
    fontWeight: 600,
    color: theme.videoconferences?.item.value,
    textTransform: 'capitalize'
  },
  arrowIcon: {
    cursor: 'pointer',
    transform: 'rotate(0deg)'
  },
  arrowIconUp: {
    cursor: 'pointer',
    transform: 'rotate(180deg)'
  }
}));

export default useStyles;
